/** Packages **/
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { common, calendar } from '../../data/constants';
import VacationSlide from './VacationSlide';
import VacationEditor from './VacationEditor';
import VacationAdder from './VacationAdder';
import CalendarActivityDetails from './CalendarActivityDetails';
import { useLanguage } from '../../context/LanguageContext';

import * as utils from '../../utilities/calendarUtilities';

const CalendarActivity = props =>  {
  const { labels } = useLanguage();
  const calendarLabels = labels.calendarLabels || {};
  const [showVacationEditor, setShowVacationEditor] = useState(false);
  const [showActivityDetails, setShowActivityDetails] = useState(false);  

  const handleClick = id => {
    const { isVacationEditable, handleVacationExtraDays, activityType } = props;

    if (activityType === 'VAE') {
      handleVacationExtraDays(id);
    } else {
      if (!isVacationEditable) {
        setShowActivityDetails(true);
      } else if (
        props.bidSession.crewinterfacemode.vacationSlideCustomMode ===
          false &&
        props.bidSession.crewinterfacemode.vacationBufferCustomMode ===
          false
      ) {
        setShowActivityDetails(true);
      } else {
        setShowVacationEditor(true);
      }
    }
  };

  const handleClose = () => {
    setShowVacationEditor(false);
    props.showNotification(calendarLabels.vacation.CHANGES_DISCARDED)
  };

  const handleCloseDetails = () => setShowActivityDetails(false);

  const handleRemove = () => {
    props.removeActivity(props.activityId);
    handleCloseDetails();
  };

  const afterSave = (message, activityData) => {
    updateCalendar(activityData);
    setShowVacationEditor(false);
    showNotification(message)
  };

  const updateCalendar = activityData => {
    if (activityData) {
      props.updateActivities(activityData);
    }
  };

  const noupdateCalendar = () => {
    showNotification('message');
  };

  const {
    activity,
    activityType,
    categoryId,
    bidSession,
    bidSessionId,
    staffId,
    activityWidth,
    leftPosition: left,
    isLowLabel,
    type,
    handleActionPreference,
    showNotification,
    activityId,
    active,
    reportMode,
    setFromAddButton
  } = props;
  const vacationSaveBody = { categoryId, bidSessionId, staffId };
  let upLabel = type;
  let lowLabel = '';
  if (isLowLabel) {
    upLabel = '';
    lowLabel = type;
  }

  let duration = activityWidth;
  if (duration === common.ZERO) {
    duration = calendar.MIN_ACTIVITY_LENGTH;
  }

  let labelHelper = '';
  if (left < 0) {
    labelHelper = 'RightLabel';
  }
  const activityStyles = {
    left,
    width: Math.floor(duration)
  };
  const {
    validatedVacationSlideStartDate: vacationSlideStartDate,
    validatedVacationSlideEndDate: vacationSlideEndDate,
    isVacationEditable,
    bidSessionStartDate,
    opacity
  } = props;
  const isRemovable = !(opacity === 1);

  const details = props.bidSession?.pairings?.find(pair => pair.activityName === props.activity.name)
  const layovers = details ? details?.pairing?.pairingDetails?.filter(details => {
    if (details.type === "LAYOVER") return details.fromStationId
  }).map(layover => layover.fromStationId).join('  ') : '---'

  return props.bidSession?.crewinterfacemode?.vacationSlideCustomMode ===
    true ? (
    <div>
      {vacationSlideStartDate && isVacationEditable && (
        <VacationSlide
          startDate={vacationSlideStartDate}
          endDate={vacationSlideEndDate}
          backgroundColor={props.backgroundColor}
          bidSessionStartDateStr={bidSession.startDateUTCStr}
          calendarStartDateStr={props.calendarStartDateStr}
          handleClick={handleClick}
          calendarHourWidth={props.calendarHourWidth}
        />
      )}
      <div className="Calendar-Activity" style={ props.displayNone ? { display: 'none' } : activityStyles}>
        {!reportMode && <div
          className={`Calendar-Activity-TypeUp ${labelHelper} ${
            props.opacity === 1 ? '' : 'calendarLabel'
          }`}
        >
          <span>{upLabel}</span>
        </div>}
        <div
          style={{
            background: props.backgroundColor,
            opacity: props.opacity,
            border: props.borderColor
              ? `1px solid ${props.borderColor}`
              : 'none'
          }}
          className={
            activityType === 'VAE'
              ? 'Calendar-Activity-Extra-Vacation'
              : 'Calendar-Activity-Fill'
          }
          data-type={activityType}
          data-activity-id={type}
        >
          <div
            onClick={!reportMode ? () => handleClick(activityId) : null}
            className="Calendar-Activity-Overlay"
          >
            {reportMode && upLabel}
          </div>
        </div>
        <div className="Calendar-Activity-TypeDown">
          {lowLabel}
          {/* reportMode && <span>seat</span> TODO */}
          {reportMode && <span>{layovers}</span> }
          {reportMode && <span>{utils.getTimeFromDateTimestamp(utils.getUTC(activity.pairings?.startInterval))}</span>}
          {reportMode && <span style={{ alignSelf: 'flex-end' }}>{utils.getTimeFromDateTimestamp(utils.getUTC(activity.pairings?.endInterval))}</span>}
          {reportMode && <span style={{ alignSelf: 'flex-end' }}>{utils.formatMinutesToHoursWithMinutes(activity.credit)}</span>}
        </div>
      </div>
      {showVacationEditor && (
        <VacationEditor
          bidSessionStartDate={bidSessionStartDate}
          activityId={props.activityId}
          startDate={props.startDateRaw}
          endDate={props.endDateRaw}
          originalStartDate={props.originalStartDate}
          originalEndDate={props.originalEndDate}
          validatedVacationSlideStartDate={props.validatedVacationSlideStartDate}
          validatedVacationSlideEndDate={props.validatedVacationSlideEndDate}
          handleClose={handleClose}
          afterSave={afterSave}
          vacationSaveBody={vacationSaveBody}
        />
      )}
      {showActivityDetails && (
        <CalendarActivityDetails
          bidSession={bidSession}
          activity={props.activity}
          activityId={props.activityId}
          activityType={props.activityType}
          activityTypeName={props.activityTypeName}
          stationId={props.stationId}
          handleClose={handleCloseDetails}
          handleRemove={handleRemove}
          isRemovable={isRemovable}
          bidPreferencesTotalEntries={props.bidPreferencesTotalEntries}
          handleActionPreference={handleActionPreference}
          showNotification={showNotification}
          setFromAddButton={setFromAddButton}
        />
      )}
    </div>
  ) : props.bidSession.crewinterfacemode.vacationBufferCustomMode ===
    true ? (
    <div>
      <div className="Calendar-Activity" style={ props.displayNone ? { display: 'none' } : activityStyles}>
        {!reportMode && <div
          className={`Calendar-Activity-TypeUp ${labelHelper} ${
            props.opacity === 1 ? '' : 'calendarLabel'
          }`}
        >
          <span>{upLabel}</span>
        </div>}
        <div
          style={{
            background: props.backgroundColor,
            opacity: props.opacity,
            border: props.borderColor
              ? `1px solid ${props.borderColor}`
              : 'none'
          }}
          className={
            activityType === 'VAE'
              ? 'Calendar-Activity-Extra-Vacation'
              : 'Calendar-Activity-Fill'
          }
          data-type={activityType}
          data-activity-id={type}
        >
          <div
            onClick={!reportMode ? () => handleClick(activityId) : null}
            className="Calendar-Activity-Overlay"
          >
            {reportMode && upLabel}
          </div>
        </div>
        <div className="Calendar-Activity-TypeDown">{lowLabel}</div>
      </div>
      {state.showVacationEditor && (
        <VacationAdder
          bidSessionStartDate={bidSessionStartDate}
          activityId={props.activityId}
          startDate={props.startDateRaw}
          endDate={props.endDateRaw}
          originalStartDate={props.originalStartDate}
          originalEndDate={props.originalEndDate}
          validatedVacationSlideStartDate={props.validatedVacationSlideStartDate}
          validatedVacationSlideEndDate={props.validatedVacationSlideEndDate}
          handleClose={handleClose}
          afterSave={afterSave}
          vacationSaveBody={vacationSaveBody}
        />
      )}
      {state.showActivityDetails && (
        <CalendarActivityDetails
          bidSession={bidSession}
          activity={props.activity}
          activityId={props.activityId}
          activityType={props.activityType}
          activityTypeName={props.activityTypeName}
          stationId={props.stationId}
          handleClose={handleCloseDetails}
          handleRemove={handleRemove}
          isRemovable={isRemovable}
          bidPreferencesTotalEntries={props.bidPreferencesTotalEntries}
          handleActionPreference={handleActionPreference}
          showNotification={showNotification}
          setFromAddButton={setFromAddButton}
        />
      )}
    </div>
  ) : (
    <div>
      <div className="Calendar-Activity" style={ props.displayNone ? { display: 'none' } : activityStyles}>
        {!reportMode && <div
          className={`Calendar-Activity-TypeUp ${labelHelper} ${
            props.opacity === 1 ? '' : 'calendarLabel'
          }`}
        >
          <span>{upLabel}</span>
        </div>}
        <div
          style={{
            background: props.backgroundColor,
            opacity: props.opacity,
            border: props.borderColor
              ? `1px solid ${props.borderColor}`
              : 'none'
          }}
          className={
            activityType === 'VAE'
              ? active
                ? 'Calendar-Activity-Extra-Vacation-Active'
                : 'Calendar-Activity-Extra-Vacation'
              : 'Calendar-Activity-Fill'
          }
          data-type={activityType}
          data-activity-id={type}
        >
          <div
            onClick={!reportMode ? () => handleClick(activityId) : null}
            className="Calendar-Activity-Overlay"
          >
              {reportMode && upLabel}
          </div>
        </div>
        <div className="Calendar-Activity-TypeDown">{lowLabel}</div>
      </div>
      {state.showActivityDetails && (
        <CalendarActivityDetails
          bidSession={bidSession}
          activity={props.activity}
          activityId={props.activityId}
          activityType={props.activityType}
          activityTypeName={props.activityTypeName}
          stationId={props.stationId}
          handleClose={handleCloseDetails}
          handleRemove={handleRemove}
          isRemovable={isRemovable}
          bidPreferencesTotalEntries={props.bidPreferencesTotalEntries}
          handleActionPreference={handleActionPreference}
          showNotification={showNotification}
          setFromAddButton={setFromAddButton}
        />
      )}
    </div>
  );
}

CalendarActivity.propTypes = {
  type: PropTypes.string.isRequired,
  activity: PropTypes.object.isRequired,
  activityId: PropTypes.number.isRequired,
  backgroundColor: PropTypes.string.isRequired,
  opacity: PropTypes.number,
  startDateRaw: PropTypes.any.isRequired,
  endDateRaw: PropTypes.any.isRequired,
  isLowLabel: PropTypes.bool,
  isVacationEditable: PropTypes.bool,
  bidSession: PropTypes.object.isRequired,
  bidSessionStartDate: PropTypes.array.isRequired,
  handleActionPreference: PropTypes.func.isRequired,
  handleVacationExtraDays: PropTypes.func.isRequired,
  showNotification: PropTypes.func.isRequired,
  removeActivity: PropTypes.func.isRequired,
  updateActivities: PropTypes.func.isRequired,
  originalStartDate: PropTypes.number.isRequired,
  originalEndDate: PropTypes.number.isRequired,
  validatedVacationSlideStartDate: PropTypes.number,
  validatedVacationSlideEndDate: PropTypes.number,
  categoryId: PropTypes.number.isRequired,
  bidSessionId: PropTypes.number.isRequired,
  staffId: PropTypes.string.isRequired,
  calendarStartDateStr: PropTypes.any,
  calendarHourWidth: PropTypes.number,
  activityWidth: PropTypes.number,
  leftPosition: PropTypes.number,
  stationId: PropTypes.string,
  activityType: PropTypes.string.isRequired,
  bidPreferencesTotalEntries: PropTypes.func.isRequired,
  reportMode: PropTypes.bool.isRequired,
  displayNone: PropTypes.bool,
  setFromAddButton: PropTypes.func
};

CalendarActivity.defaultProps = {
  isLowLabel: false,
  opacity: 1,
  validatedVacationSlideStartDate: null,
  validatedVacationSlideEndDate: null,
  isVacationEditable: false,
  calendarStartDateStr: null,
  calendarHourWidth: 0,
  activityWidth: 0,
  leftPosition: 0,
  stationId: '',
  reportMode: false,
  displayNone: false,
  setFromAddButton: () => {}
};

export default CalendarActivity;
